// src/modules/auth/contexts/auth-context.tsx
'use client';

import React, { useContext, ReactNode } from 'react';

import { AuthUser } from '../modules/auth/types/auth';
import { useAuthStore } from '../modules/auth/stores/auth-store';
import { AuthContext } from './auth-context';
import { useProfileStore } from '@/profile';
import { getFirebaseAuth } from '@/shared/utils';
import { useRouter } from 'next/navigation';

export type AuthContextType = {
  user: AuthUser | null;
};

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const { user, clearAuth, hydrated } = useAuthStore();
  const { profile, resetStore } = useProfileStore();
  const router = useRouter();

  const logout = async () => {
    clearAuth();
    try {
      const auth = await getFirebaseAuth();
      await auth.signOut();

      resetStore();
      router.push('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, profile, logout, hydrated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useServerAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useServerAuth deve essere usato all’interno di un AuthProvider');
  }
  return context;
};
export { AuthContext };
